module.exports = __webpack_public_path__ + "img/7.f6631c28.jpg";